import { Link, useLocation, type LinkProps } from 'react-router-dom';
import { localize, splitLocale } from '../lib/locale-paths.ts';

/**
 * 公开页面里的站内链接：当前在 /en/… 上，指向首页、功能介绍这几页的链接就换成 /en/… 的（lib/locale-paths.ts）。
 * 不然英文页上点「功能介绍」会掉回简体网址，搜索引擎顺着链接爬也全是简体。
 * 别的链接（/docs、/p/…、登录）原样不动。用法和 react-router 的 Link 一模一样。
 */
export function PLink(props: LinkProps): React.ReactElement {
  const loc = useLocation();
  const { locale } = splitLocale(loc.pathname);
  const to = typeof props.to === 'string' ? localize(props.to, locale.prefix) : props.to;
  return <Link {...props} to={to} />;
}
